import { useEffect } from 'react';

export const SEO = ({ title, description, path = '', schema = null }) => {
  const siteName = 'HYDROX STUDIOS';
  const baseUrl = 'https://studio.hydroxmusic.com';
  const fullTitle = title
    ? `${title} | ${siteName}`
    : `${siteName} - Music Video & Audio Production in Guwahati`;

  const fullUrl = `${baseUrl}${path}`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    setMeta('description', description);

    const setOG = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    setOG('og:title', fullTitle);
    setOG('og:description', description);
    setOG('og:url', fullUrl);
    setOG('og:type', 'website');
    setOG('og:site_name', siteName);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = fullUrl;

    // Inject Schema
    if (schema) {
      let script = document.getElementById('schema-markup');
      if (script) script.remove();

      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'schema-markup';
      script.innerHTML = JSON.stringify(schema);
      document.head.appendChild(script);
    }

  }, [fullTitle, description, fullUrl, schema]);

  return null;
};